import React from 'react'
import { AdminNodeContainer } from '../../'

const AdminHouseType = (props) => {
  const {
    config,
    rootNode,
  } = props

  return (
    <AdminNodeContainer
      config={config}
      rootNode={rootNode}
    />
  )
}

export default AdminHouseType



// WEBPACK FOOTER //
// ./src/modules/admin/components/adminHouseType.jsx